
import { updateAppConfig } from '#app'
import { defuFn } from '/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/node_modules/defu/dist/defu.mjs'

const inlineConfig = {
  "nuxt": {
    "buildId": "493124ea-b635-4401-a668-b4422adcd1bf"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /* #__PURE__ */ defuFn(inlineConfig)
